export default {
    documents: {
        title: '文書',
        loading: '読み込み中...',
        retry: '再試行',
        noDocuments: '文書がありません',
        createFirst: '最初の文書を作成',

        // Document types
        types: {
            disclosure: '技術開示書',
            patent_draft: '特許草稿',
            prosecution: '応答書',
            patent_claim: 'クレーム',
            specification: '明細書',
            rejection_comparison: '拒絶対比',
            technical_doc: '技術文書',
            other: 'その他',
        },

        // Time formatting
        time: {
            today: '今日',
            yesterday: '昨日',
            daysAgo: '{count} 日前',
        },

        // Actions
        actions: {
            delete: '削除',
            edit: '編集',
            download: 'ダウンロード',
            open: '開く',
        },

        // Rename dialog
        rename: {
            title: '文書名を変更',
            confirm: '保存',
            cancel: 'キャンセル',
            inputErrorMessage: '文書名を入力してください',
        },

        // Content preview
        preview: {
            noContent: 'コンテンツなし',
            wordCount: '{count} 文字',
        },

        // Delete confirmation
        deleteConfirm: {
            title: '文書を削除',
            message: '「{title}」を削除してもよろしいですか？',
            confirm: '削除',
            cancel: 'キャンセル',
        },

        // Messages
        deleteSuccess: '文書を削除しました',
        renameSuccess: '文書名を変更しました',
        downloadSuccess: '文書をダウンロードしました',

        // Errors
        errors: {
            loadFailed: '文書の読み込みに失敗しました',
            openFailed: '文書を開けませんでした',
            deleteFailed: '文書の削除に失敗しました',
            renameFailed: '文書名の変更に失敗しました',
            downloadFailed: '文書のダウンロードに失敗しました',
        },
    },
};
